import React, { useState, useEffect ,useContext} from "react";
import { makeStyles } from "@material-ui/core";
import { useMediaQuery } from "react-responsive";
import { Grid, Typography, Button } from "@material-ui/core";
import NewsItem1 from "../../../../../assests/Bluegreen-small.jpg";
import NewsItem2 from "../../../../../assests/news3-2.jpg";
import Mar1 from "../../../../../assests/mar1.png";
import Mar2 from "../../../../../assests/mar2.png";
import Mar3 from "../../../../../assests/mar3.png";
import Mar4 from "../../../../../assests/mar4.png";
import Mar5 from "../../../../../assests/mar5.png";
import "./_content.css";
import EDetailedContent from "./_detailedContent";
import { useSelector,useDispatch } from "react-redux";
import { Skeleton } from "@material-ui/lab";
import SearchBar from "../../e_search_bar/e_search_bar";
import { contentData } from "../model/mock";
import { contentsService } from "../model/service";
import { useTranslation } from "react-i18next";
import ReactDOMServer from 'react-dom/server';
import {imagesapi,contentapi} from "../../../model/action"
const useStyles = makeStyles((theme) => ({
  contentHeading: {
    fontWeight: "bolder",
    color: theme.palette.ePrimary.base,
   // marginTop: "0.8rem",
    lineHeight: "25px",
  },
  contentData: {
    display: "flex",
    flexDirection: "column",
    color: theme.palette.eRich.base,
    marginTop: "0.5rem",
  },
  title: {
    fontWeight: "bolder",
    color: theme.palette.ePrimary.base,
  },
  newsItemContainer: {
    color: theme.palette.eRich.base,
    display: "flex",
    [theme.breakpoints.up("xs")]: {
      flexDirection: "column",
      margin: "auto",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
      flexDirection: "row",
      margin: "initial",
    },
  },
  contentPosition:{
    position: 'relative',
    overflow:'scroll',
    //top: '-2rem',
    [theme.breakpoints.down("md")]: {
      top: '0rem',
      marginBottom: '1rem'
    },
  },
  newsImage: {
    [theme.breakpoints.up("xs")]: {
      height: "6rem",
      margin: "auto 0px",
      height: "auto",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
      margin: "initial",
      height: "fit-content",
    },
  },
  newsData: {
    lineHeight: 1.2,
    fontSize: "0.688rem",
    [theme.breakpoints.up("xs")]: {
      marginLeft: "0px",
      textAlign: "justify",
    },
    [theme.breakpoints.up("md")]: {
      marginLeft: "5px",
      textAlign: "left",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
    },
  },
  p5: {
    padding: "0% 5% 6% 5%",
  },
  readMoreLink: {
    textDecoration: "underline" + theme.palette.ePrimary.base,
    textTransform: "none",
    color: theme.palette.ePrimary.base,
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    display: "inline",
    marginTop: "0.3rem",
    padding: 0,
    fontSize: "0.75rem",
  },
  marquee: {
    height: "10vh",
    overflow: "hidden",
    [theme.breakpoints.up("xs")]: {
      width: "80vw",
    },
    [theme.breakpoints.up("md")]: {
      width: "100%",
    },
  },
  mb5: {
    marginBottom: "5%",
  },
  mt2: {
    marginTop: "2%",
  },
  skeleton: {
    width: "100%",
    height: "100%",
  },
  breakWord: {
    wordWrap: "break-word",
    lineHeight: "1.4",
    textAlign:'justify'
  },
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
  contentLinkButton: {
    borderRadius: 29,
    backgroundColor: theme.palette.eSecondary.base,
    color: theme.palette.eWhite.base,
    "&:hover": {
      backgroundColor: theme.palette.eSecondary.hover,
    },
  },
  welcomeHeight: {
    height: "90%",
  },
  mainContentcss: {
    lineHeight: "1.4",
  },
  welcomeColor:{
    color: theme.palette.ePrimary.base,
    fontSize:'1.9rem',
    fontWeight: "bolder",
  },
  scrollBar:{
    maxHeight: '50vh',
    overflow:'scroll',
  ' &::-webkit-scrollbar-corner':{
    backgroundColor: "transparent"
  }
  },
  toColor:{
    color: theme.palette.ePrimary.base,
    fontWeight: "bolder",
  }
}));

function EContentView({ scrollTo, getContentsApi }) {
  const {t:labels, ready: labelReady} = useTranslation('label-E_AUTH_LOGIN');
  const {t:contents, ready: contentReady} = useTranslation('content-E_LANDING_PAGE_CONTENT_SECTION');
  const dispatch = useDispatch();
  const { NEWS_DATA, CLIENT_DATA } = contentData;
  const languageCode = useSelector(
    (state) =>
      state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
  );
  const [news1Content, setNews1Content] = useState();
  const [news2Content, setNews2Content] = useState();
  const [news1Image, setNews1Image] = useState();
  const [news2Image, setNews2Image] = useState();

  const [clientData, setClientData] = useState([]);
  const [mainContent, setMainContent] = useState(null);
  const [welcomeText, setWelcomeText] = useState(null);
  const [assetData, setAssetData] = useState([]);
  // useEffect(() => {
  //   let tempAssetData = [];
  //   if (languageCode) {
  //     dispatch(imagesapi(true))
  //     NEWS_DATA.forEach((item, index) => {
  //       contentsService.getAssetData(item.ASSET_CODE).then((res) => {
  //         if (index == 0) setNews1Image({ ...res });
  //         if (index == 1) setNews2Image({ ...res });
  //         dispatch(imagesapi(false))
  //       })
  //       .catch(()=>{
  //            dispatch(imagesapi(false))
  //            })
  //     });
     
  //   }
  // }, [languageCode]);
  useEffect(() => {
    if (contentReady) {
      setNews1Content(contents(NEWS_DATA[0].CONTENT_CODE)?.answer);
      setNews2Content(contents(NEWS_DATA[1].CONTENT_CODE)?.answer);
      setMainContent(contents("E_LANDING_PAGE_ABJAYON_CONTENT")?.answer);
      setWelcomeText(contents("E_LANDING_PAGE_WELCOME_TEXT")?.answer);
      dispatch(contentapi(false))
    }
  }, [contentReady,contents]);
  const classes = useStyles();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 550px)" });
  const [detailedContent, setDetailedContent] = useState(false);
  const [abjayonTab, setAbjayonTab] = useState(true);

  let readMoreClick = () => {
    setDetailedContent(true);
    setAbjayonTab(false);
  };

  let backToAbjayon = () => {
    setDetailedContent(false);
    setAbjayonTab(true);
  };

  return (
    <>
      {isTabletOrMobile ? (
        <React.Fragment>
          {abjayonTab && (
            <Grid container spacing={2} className={classes.p5}>
              <Grid xs={12} item>
              <Typography className={classes.toColor}  variant="h5"><span className={classes.welcomeColor}>{labels("E_WELCOME_TEXT")} </span>{labels("E_WELCOME_TO")}</Typography>
                {welcomeText ? (
                  <Typography
                    className={classes.contentHeading}
                    variant="h5"
                    color="primary"
                    dangerouslySetInnerHTML={{
                      __html: welcomeText,
                    }}
                  ></Typography>
                ) : (
                  <Skeleton variant="text" />
                )}
              </Grid>
              <Grid xs={12} item >
                  <Typography 
                  variant="subtitle2" 
                  className={classes.breakWord}
                  dangerouslySetInnerHTML={{
                      __html: mainContent,
                    }}
                  >
                </Typography>
                {/* <Typography
                  variant="subtitle2"
                  className={classes.readMoreLink}
                  onClick={readMoreClick}
                >
                  {labelReady ? labels("E_LANDING_PAGE_READ_MORE_LABEL") : <Skeleton />}
                </Typography> */}
              </Grid>
              {/* <Grid item xs={12} className={classes.mt2}>
                <Typography variant="subtitle2" className={classes.title}>
                  {labelReady ? labels("E_AUTH_CONTENTS_SECTION_NEWS_HEADING") : <Skeleton />}
                </Typography>

                <Grid container spacing={2} className={classes.flexColumn}>
                  <Grid item xs={12} className={classes.newsItemContainer}>
                    <img
                      className={classes.newsImage}
                      src={news1Image?.assetPath}
                    />
                    <Typography
                      variant="body2"
                      noWrap
                      className={classes.newsData}
                      dangerouslySetInnerHTML={{
                        __html: news1Content,
                      }}
                    />
                  </Grid>
                  <Grid xs={12} item className={classes.newsItemContainer}>
                    <img
                      className={classes.newsImage}
                      src={news2Image?.assetPath}
                    />
                    <Typography
                      variant="body2"
                      className={classes.newsData}
                      dangerouslySetInnerHTML={{
                        __html: news2Content,
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid> */}
              {/* <Grid item xs={12} className={classes.mb5}>
                <Typography variant="h6" className={classes.title}>
                  {labelReady ? labels("E_AUTH_CONTENTS_SECTION_NEWS_HEADING") : <Skeleton />}
                </Typography>
                <div class="marquee">
                  <ul class="marquee-content">
                    {CLIENT_DATA.map((client) => {
                      return (
                        <li class="marquee-item">
                          <img
                            className="marquee-image"
                            src={
                              clientData &&
                              clientData.find(
                                (item) => item.assetCode === client.ASSET_CODE
                              )?.assetPath
                            }
                          />
                        </li>
                      );
                    })}
                    {/* for continuous scrolling effect */}
                    {/* {CLIENT_DATA.map((client) => {
                      return (
                        <li class="marquee-item">
                          <img
                            className="marquee-image"
                            src={
                              clientData &&
                              clientData.find(
                                (item) => item.assetCode === client.ASSET_CODE
                              )?.assetPath
                            }
                          />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </Grid>  */}
            </Grid>
          )}
          {/* {detailedContent && (
            <EDetailedContent
              title={welcomeText}
              labels={labels}
              labelReady={labelReady}
              toggleTab={backToAbjayon}
            />
          )} */}
        </React.Fragment>
      ) : (
        <React.Fragment>
          {abjayonTab && (
            <Grid container spacing={2} className={classes.welcomeHeight}>
              <Grid xs={12} item>
              <Typography className={classes.toColor}  variant="h5"><span className={classes.welcomeColor}>{labels("E_WELCOME_TEXT")} </span>{labels("E_WELCOME_TO")}</Typography>
                {welcomeText ? (
                  <Typography
                    className={classes.contentHeading}
                    variant="h5"
                    color="primary"
                    dangerouslySetInnerHTML={{
                      __html: welcomeText,
                    }}
                  ></Typography>
                ) : (
                  <Skeleton variant="text" />
                )}
              </Grid> 
              <Grid item xs={12} className={classes.scrollBar}>
              <Typography 
                  variant="subtitle2" 
                  className={[classes.breakWord,classes.contentPosition]}
                  dangerouslySetInnerHTML={{
                      __html: mainContent,
                    }}
                  > 
                </Typography>
              </Grid>
            </Grid>
          )}
          {detailedContent && (
            <EDetailedContent
              title={welcomeText}
              labels={labels}
              toggleTab={backToAbjayon}
            />
          )}
        </React.Fragment>
      )}
    </>
  );
}
export default EContentView;
